import { AnalyticsDirective } from './directives/analytics.directive';
import { NgModule } from '@angular/core';
import { AppLinkDirective } from './directives/app-link.directive';
import { LoggerHandlerService } from '../logging/services/logger-handler.service';

@NgModule({
    declarations: [AnalyticsDirective, AppLinkDirective],
    exports: [AnalyticsDirective, AppLinkDirective],
    providers: [LoggerHandlerService]
})
export class MaxCommonModule { }
